import React, { useState, useEffect, useMemo } from "react";
import Compradores from "../Compradores";
import CarModal from "../UserCar";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "../../style/AllUsers.css";
import { useAuth } from "../../context/AuthContext";
import api from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";


function AllUsers() {
  const [users, setUsers] = useState([]);
  const [usersTemp, setUsersTemp] = useState([])
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [username, setUsername] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  const [nombres, setnombres] = useState([]);
  const [input, setInput] = useState("");
  const [, setSelectedName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [fulluser, setfulluser] = useState([]);
  const [, setUserid] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });

  const getSortValue = (user, key) => {
    if (key === "carroscomprados") {
      return user.carroscomprados ? user.carroscomprados.length : 0;
    }
    if (key === "saldo") {
      return Number(user.saldo) || 0;
    }
    return 0;
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "desc" };
    });
  };

  const sortedUsers = useMemo(() => {
    if (!sortConfig.key) return users;
    const copy = [...users];
    copy.sort((a, b) => {
      const aVal = getSortValue(a, sortConfig.key);
      const bVal = getSortValue(b, sortConfig.key);
      return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
    });
    return copy;
  }, [users, sortConfig]);

  const findallusernames = async () => {
    const res = await api.get("usuario");
    const data = res.data;
    const usernames = [];
    data.forEach((usuario) => {
      if (usuario.nombre) {
        usernames.push(usuario.nombre);
      }
    });
    setfulluser(data);
    setnombres(usernames);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInput(value);
    detectInputType(value);
  };

  const fuse = new Fuse(
    nombres.map((nombre) => ({ nombre: nombre })),
    {
      threshold: 0.9,
      distance: 100,
      minMatchCharLength: 3,
      keys: ["nombre"],
    }
  );

  const detectInputType = (value) => {
    setSelectedName("");
    const valueTrim = value.trim();
    let matches = [];
    const suggestions = fuse.search(valueTrim);
    setSuggestions(suggestions.map((suggestion) => suggestion.item.nombre));
    if (
      nombres.some((nombre) => nombre.toLowerCase() === valueTrim.toLowerCase())
    ) {
      matches.push({ type: "nombre", value: valueTrim });
    }
    if (matches.length === 0) {
      matches.push({ type: "unknown", value: value }); // Fallback if no matches found
    }
  };

  const finduser = (username) => {
    const matchedUser = fulluser.find(
      (user) => user.nombre.toLowerCase() === username.toLowerCase()
    );
    setUserid(matchedUser._id);
    const foundObject = users.find(item => item._id === matchedUser._id);
    setUsers([foundObject])
  };

  const limpiar = () => {
    setUsers(usersTemp)
  }

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion);
    setSuggestions([]);
    finduser(suggestion);
  };

  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      setLoading(true);
      try {
        const response = await api.get("usuario");
        setUsers(response.data);
        setUsersTemp(response.data)
        setError(null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
        setUsers([]);
      }
      await setLoading(false);
    };

    const getUser = async () => {
      try {
        const response = await api.get("usuario/getbyToken");
        setUsername(response.data.nombre);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
      }
    };

    const inicio = async () => {
      if (authToken !== null) {
        await getUser();
        await fetchAllUsers();
        await findallusernames();
      } else {
        navigate("/");
      }
    };

    inicio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-all">Listado de Compradores</p>
            <div className="searchbar-container">
            <div
              className={`search-bar-mod-allusers ${
                suggestions.length > 0 ? "show-suggestions" : ""
              }`}
            >
              <input
                type="text"
                id="Search"
                value={input}
                onChange={handleChange}
                placeholder=" Nombre del comprador"
              />
              {suggestions.length > 0 && (
                <ul className="suggestions-list-mod">
                  {suggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleSuggestionClick(suggestion)}
                      className="suggestion-item"
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <button class="red-button" onClick={() => limpiar()}>Limpiar Filtro</button>
            </div>
            <div className="column-titles">
              <p className="column-title">Nombre</p>
              <p className="column-title">Correo</p>
              <button
                type="button"
                className={`column-title column-title--sortable${
                  sortConfig.key === "carroscomprados" ? " column-title--active" : ""
                }`}
                onClick={() => handleSort("carroscomprados")}
                aria-label="Ordenar por carros comprados"
              >
                <span>Carros comprados</span>
                <span className="sort-arrows" aria-hidden="true">
                  <span
                    className={`sort-arrow${
                      sortConfig.key === "carroscomprados" && sortConfig.direction === "asc"
                        ? " sort-arrow--active"
                        : ""
                    }`}
                  >
                    ▲
                  </span>
                  <span
                    className={`sort-arrow${
                      sortConfig.key === "carroscomprados" && sortConfig.direction === "desc"
                        ? " sort-arrow--active"
                        : ""
                    }`}
                  >
                    ▼
                  </span>
                </span>
              </button>
              <button
                type="button"
                className={`column-title column-title--sortable${
                  sortConfig.key === "saldo" ? " column-title--active" : ""
                }`}
                onClick={() => handleSort("saldo")}
                aria-label="Ordenar por saldo"
              >
                <span>Saldo</span>
                <span className="sort-arrows" aria-hidden="true">
                  <span
                    className={`sort-arrow${
                      sortConfig.key === "saldo" && sortConfig.direction === "asc"
                        ? " sort-arrow--active"
                        : ""
                    }`}
                  >
                    ▲
                  </span>
                  <span
                    className={`sort-arrow${
                      sortConfig.key === "saldo" && sortConfig.direction === "desc"
                        ? " sort-arrow--active"
                        : ""
                    }`}
                  >
                    ▼
                  </span>
                </span>
              </button>
            </div>
            <div
              className="overview-container"
              style={{
                overflow: "auto",
                maxHeight: "700px",
                alignItems: "flex-start",
              }}
            >
              {sortedUsers.map((user) => (
                <div className="overview-item" key={user._id} onClick={() => handleUserClick(user)}>
                  <Compradores user={user} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {selectedUser && (
        <CarModal  userId={selectedUser._id} showModal={!!selectedUser} onClose={handleCloseModal} />
      )}
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AllUsers;
